import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ScheduleTimelineComponent } from '../schedule-timeline.component';

@Component({
  selector: 'md-schedule-timeline-graph',
  templateUrl: './schedule-timeline-graph.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleTimelineGraphComponent extends ScheduleTimelineComponent {
  constructor() {
    super();
  }
}
